$(document).on('ready', function () {
    $('.js_number').on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
    })

    $('.js_baggage-modal-open').on('click', function () {
        $('#js_baggage-modal').addClass('is-show');
    })

    $('.js_baggage-modal-reset').on('click', function () {
        $('.js_baggage-modal-open').attr('data-count', 0);
        $('#specify_baggage').val(0);
        $('#js_baggage-modal').removeClass('is-show');

        $('.js_baggage-dynamic-container').children().remove();
        $('.js_baggage-dynamic__input').val($('.js_baggage-dynamic-container').children().length).trigger('change');
        $('#js_baggage-modal').find('.js_countable-input').each(function () {
            let self = $(this);

            self.val(self.data('min')).trigger('change').siblings('[data-func="inc"]').prop('disabled', false).siblings('button').prop('disabled', true);
        });
    })

    $('.js_baggage-modal-submit').on('click', function () {
        let count = 0;
        $('#js_baggage-modal').find('.js_countable-input').each(function () {
            let self = $(this);
            count += Number(self.val());
        });
        count += Number($('.js_baggage-dynamic-container').children().length);
        $('.js_baggage-modal-open').attr('data-count', count);
        $('#specify_baggage').val(count ? 1 : 0);
        $('#js_baggage-modal').removeClass('is-show');
    })

    $('.js_baggage-dynamic-inc').on('click', function () {
        let container = $('.js_baggage-dynamic-container'),
            index = container.children().length + 1,
            itemsContainer = $('.iframe-baggage-modal__items'),
            name = $(this).data('name');

        container.append(getDynamicElem(index, name));

        $('.js_baggage-dynamic__input').val(index).trigger('change');

        itemsContainer.scrollTop(itemsContainer[0].scrollHeight);
        container.scrollLeft(container[0].scrollWidth);
    })

    $('.js_baggage-type-count').on('change', function () {
        let cost = 0;
        $('.js_baggage-type-count').each(function () {
            cost += ($(this).data('cost') * $(this).val());

            cost ? $('.js_baggage-modal-submit').attr('data-additional-cost', cost) : $('.js_baggage-modal-submit').removeAttr('data-additional-cost');
        })
    })

    $(document)
        .on('click', '.js_baggage-dynamic-dec', function () {
            $(this).closest('.js_baggage-dynamic-item').remove();
            $('.js_baggage-dynamic-container').children().each(function (index, elem) {
                $(elem).find('input').each(function (i, input) {
                    $(input).attr('name', $(input).attr('name').replace(/\d+/, index + 1));
                })
            })
            $('.js_baggage-dynamic__input').val($('.js_baggage-dynamic-container').children().length).trigger('change');
        })
        .on('click', '.js_baggage-dynamic-remove', function () {
            $(this).siblings('input').val('');
        })

    function getDynamicElem(index, name = "Нестандарт") {
        return '<div class="iframe-baggage-modal-subitem js_baggage-dynamic-item">' +
            '<div class="iframe-baggage-modal-subitem__heading">' +
            '    <span class="iframe-baggage-modal-subitem__name">Багаж "'+ name +'"</span>' +
            '    <button type="button" class="iframe-baggage-modal-subitem__remove js_baggage-dynamic-dec">' +
            '       <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '    </button>' +
            '</div>' +
            '<div class="iframe-baggage-modal-subitem__sizes">' +
            '    <div class="iframe-baggage-modal-subitem-group">' +
            '        <input class="iframe-baggage-modal-subitem-group__input js_number" type="text" name="baggage[' + index + '][length]" value="" />' +
            '        <label class="iframe-baggage-modal-subitem-group__label" for="">Длина см</label>' +
            '        <button type="button" class="iframe-baggage-modal-subitem-group__remove js_baggage-dynamic-remove">' +
            '          <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '        </button>' +
            '    </div>' +
            '    <div class="iframe-baggage-modal-subitem-group">' +
            '        <input class="iframe-baggage-modal-subitem-group__input js_number" type="text" name="baggage[' + index + '][width]" value="" />' +
            '        <label class="iframe-baggage-modal-subitem-group__label" for="">Ширина см</label>' +
            '        <button type="button" class="iframe-baggage-modal-subitem-group__remove js_baggage-dynamic-remove">' +
            '          <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '        </button>' +
            '    </div>' +
            '    <div class="iframe-baggage-modal-subitem-group">' +
            '        <input class="iframe-baggage-modal-subitem-group__input js_number" type="text" name="baggage[' + index + '][height]" value="" />' +
            '        <label class="iframe-baggage-modal-subitem-group__label" for="">Высота см</label>' +
            '        <button type="button" class="iframe-baggage-modal-subitem-group__remove js_baggage-dynamic-remove">' +
            '          <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '        </button>' +
            '    </div>' +
            '</div>' +
            '<div class="iframe-baggage-modal-subitem__description">' +
            '    <div class="iframe-baggage-modal-subitem-group">' +
            '        <input class="iframe-baggage-modal-subitem-group__input" type="text" name="baggage[' + index + '][description]" value="" />' +
            '        <label class="iframe-baggage-modal-subitem-group__label" for="">Описание</label>' +
            '        <button type="button" class="iframe-baggage-modal-subitem-group__remove js_baggage-dynamic-remove">' +
            '          <svg class="icon"><use xlink:href="#icon-svg-baggage-close"></use></svg>' +
            '        </button>' +
            '    </div>' +
            '</div>' +
            '</div>';
    }
})